import { render } from "./NabpReport.vue?vue&type=template&id=056d58fd"
import script from "./NabpReport.vue?vue&type=script&lang=js"
export * from "./NabpReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__